import { tVariants } from '../../style-system';

const expandableContentStyles = tVariants({
    base: 'relative data-[state="truncated"]:mb-9',
    slots: {
        contentContainer:
            'relative overflow-hidden transition-[max-height] duration-[--expand-duration] data-closed:max-h-[--closed-height]  data-open:max-h-[--open-height]',
        overlay: 'z-10 absolute w-full  inset-0 top-1/3 bg-gradient-to-b from-transparent to-current-bg',
        buttonContainer: 'flex items-center absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-12 z-20',
    },
});

export { expandableContentStyles };
